import { create } from "zustand"
import { Notification } from "../interfaces/NotificationLog/notification"


interface NotificationTypeStore {
    showDetailNotification: boolean
    setShowDetailNotification: (showDetailNotification: boolean) => void
    detailNotification: Notification
    setDetailNotification: (detailNotification: Notification) => void
}

const useNotificationStore = create<NotificationTypeStore>((set) => ({
    showDetailNotification: false,
    setShowDetailNotification: (showDetailNotification) => set({ showDetailNotification }),
    detailNotification: {} as Notification,
    setDetailNotification: (detailNotification) => set({ detailNotification })
}))

export default useNotificationStore